import { createAction, props } from '@ngrx/store';

export const loadDefaultLocale = createAction(
  '[Locale] Load Default Locale',
  props<{ locale: string }>()
);
export const updateDefaultLocale = createAction(
  '[Locale] Update Default Locale',
  props<{ locale: string }>()
);
export const loadLocales = createAction('[Locale] Load Locales');

export const loadLocalesSuccess = createAction(
  '[Locale] Load Locales Success',
  props<{ data: any }>()
);

export const loadLocalesFailure = createAction(
  '[Locale] Load Locales Failure',
  props<{ error: any }>()
);
export const loadAppKeyValues = createAction(
  '[Locale] Load AppKeyValues',
  props<{ option?: any }>()
);

export const loadAppKeyValuesSuccess = createAction(
  '[Locale] Load AppKeyValues Success',
  props<{ data: any }>()
);

export const loadAppKeyValuesFailure = createAction(
  '[Locale] Load AppKeyValues Failure',
  props<{ error: any }>()
);
